import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingErrorMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Number} param.data.httpStatusCode
   */
  map({page, culture, data}) {
    const {httpStatusCode} = data
    const trackingData = {
      page_error: `error_${httpStatusCode}`
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
